import React from 'react';
import './App.css';
import PortfolioLayout from './components/portfolio-layout/portfolio-layout.js';
import HomePage from './components/home-page/home-page.js';
import FixedTopBar from './components/fixedtopbar/fixedtopbar.js';

function App() {
  return (
    <div className="App">
      <PortfolioLayout>
        <FixedTopBar/>
        <HomePage />
      </PortfolioLayout>
    </div>
  );
}

export default App;